<template>
	<div>
		<b-form-file
			v-model="file"
			placeholder="Datei auswählen..."
			drop-placeholder="Foto hier reinziehen..."
			browse-text="Datei wählen"
			accept="image/*, application/pdf"
			@input="emitChangeEvent"
		/>
		<Requirements :requirements="requirements" />
	</div>
</template>

<script>
import {toBase64} from "@/helper/File";
import Requirements from "@/vue/common/form/group/Requirements";

const TEN_MEGABYTE = 10000000;

export default {
	components: {Requirements},
	data ()
	{
		return {
			file: null,
		};
	},

	computed: {
		requirements ()
		{
			return [
				{
					key: 'type',
					label: 'Bild oder PDF',
					valid: this.typeValid,
				},
				{
					key: 'size',
					label: 'Dateigröße (maximal 10 MB)',
					valid: this.sizeValid,
				},
			];
		},
		typeValid ()
		{
			return this.file
				&& (this.file.type.startsWith('image/') || this.file.type === 'application/pdf')
		},
		sizeValid ()
		{
			return this.file && this.file.size <= TEN_MEGABYTE;
		},
		fileValid ()
		{
			return this.typeValid && this.sizeValid;
		},
	},

	methods: {
		async emitChangeEvent ()
		{
			if (!this.file || !this.fileValid)
			{
				this.$emit('input', null);
				return;
			}

			this.$emit('input', {
				name: this.file.name,
				mimeType: this.file.type,
				size: this.file.size,
				base64: (await toBase64(this.file))
			});
		}
	}
}
</script>